(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["collection-pods__faq"]) return;
  try {
    
$("[data-action=toggleAccordion]").on("click",function(){
  $(this).find(".faq-answer").slideToggle();
  $(this).toggleClass("open");
  return false;
});    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection__faq"]) return;
  try {
    
$("[data-action=toggleAccordion]").on("click",function(){
  $(this).find(".faq-answer").slideToggle();
  $(this).toggleClass("open");
  return false;
});    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection__setup"]) return;
  try {
    
if($(window).width() < 799) {
  console.info("✅ Slider init");                        
  $('#sliderSetup').flickity({
    // options
    cellAlign: 'center',
    contain: true,
    pageDots: false,
    arrowShape: arrowShape
  });
}                         

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq_multo"]) return;
  try {
    
$("[data-action=toggleAccordion]").on("click",function(){
  $(this).find(".faq-answer").slideToggle();
  $(this).toggleClass("open");
  return false;
});    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index__pap_medias"] && !window.DesignMode) return;
  try {
    
if($(window).width() < 799) {
$('#sliderMedias').flickity({
  // options
  cellAlign: 'center',
  contain: true,
  pageDots: false,
  arrowShape: arrowShape
});
}                        

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page__about-team"]) return;
  try {
    
if($(window).width() < 799) {
  console.info("✅ Slider init");                        
  $('#sliderTeam').flickity({
    // options
    cellAlign: 'center',
    contain: true,
    pageDots: false,
    arrowShape: arrowShape
  });
}                         

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-pods__faq"]) return;
  try {
    
$("[data-action=toggleAccordion]").on("click",function(){
  $(this).find(".faq-answer").slideToggle();
  $(this).toggleClass("open");
  return false;
});    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product__faq"]) return;
  try {
    
$("[data-action=toggleAccordion]").on("click",function(){
  $(this).find(".faq-answer").slideToggle();
  $(this).toggleClass("open");
  return false;
});    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product__reviews"]) return;
  try {
    
$('#reviews').flickity({
  // options
  cellAlign: 'center',
  contain: true,
  pageDots: true,
  arrowShape: arrowShape,
  groupCells: true
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product__setup"]) return;
  try {
    
if($(window).width() < 799) {
  console.info("✅ Slider init");                        
  $('#sliderSetup').flickity({
    // options
    cellAlign: 'center',
    contain: true,
    pageDots: false,
    arrowShape: arrowShape
  });
}                         

  } catch(e) { console.error(e); }
})();

})();
